var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "well",
    class: {
      collapsed: _vm.isCollapsed
    }
  }, [_c('div', {
    staticClass: "filters"
  }, [_vm._t("filters"), _vm._v(" "), _vm.showAdvanced ? [_vm._t("advanced-filters")] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._t("actions", function () {
    return [_c('div', {
      staticClass: "actions-left"
    }, [_vm._t("actions-left", function () {
      return [_vm.showAdvancedOption ? _c('VButton', {
        staticClass: "ghost primary",
        on: {
          "click": function () {
            return _vm.showAdvanced = !_vm.showAdvanced;
          }
        }
      }, [_vm._v("\n            " + _vm._s(_vm.advancedLabel) + "\n          ")]) : _vm._e()];
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "actions-right"
    }, [_vm._t("actions-right", function () {
      return [_vm.showClear ? _c('VButton', {
        staticClass: "ghost destructive",
        on: {
          "click": _vm.emitClear
        }
      }, [_vm._v("\n            Clear All\n          ")]) : _vm._e(), _vm._v(" "), _vm.showSubmit ? _c('VButton', {
        staticClass: "primary",
        on: {
          "click": _vm.emitSubmit
        }
      }, [_vm._v("\n            Submit\n          ")]) : _vm._e()];
    })], 2)];
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }